__webpack_require__.p = "//s3.meituan.net/static-prod01/ws-assets/com.sankuai.show.mmh5.static/IkEwpe6nV97kcpw3KTmDo/";